import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TaskItem, TaskItemCreate, TaskItemFilter } from '../data/taskItem';

export function createTaskItemService(client: AxiosInstance) {
  return createCrudService<TaskItem, TaskItemCreate, TaskItemFilter>(
    client,
    '/crm/TaskItem',
    'id',
  );
}

export type TaskItemService = CrudService<TaskItem, TaskItemCreate, TaskItemFilter>;
